import { computed } from 'vue'
import { useQuery } from '@tanstack/vue-query'
import fetchData from '@/util/fetch'

// The meter and its communicator live at Cast4all (/meters/{serial}/c4a): registration, readings and the
// communicator type, which says what kind of meter it is. Free calls, so it loads with a Cast4all meter;
// kept a minute so going back to the meter does not refetch. The meter table and the details modal share it.
export function useC4aStatus(serialNumber, enabled) {
  return useQuery({
    queryKey: computed(() => ['meterC4a', serialNumber.value]),
    queryFn: async () => {
      const result = await fetchData(`/eleena/api/v1/meters/${serialNumber.value}/c4a`)
      return result?.data ?? null
    },
    enabled: computed(() => !!serialNumber.value && enabled.value),
    refetchOnWindowFocus: false,
    staleTime: 60 * 1000,
    retry: false,
  })
}
